import { render, staticRenderFns } from "./extend.vue?vue&type=template&id=bf395fea&scoped=true&"
import script from "./extend.vue?vue&type=script&lang=js&"
export * from "./extend.vue?vue&type=script&lang=js&"
import style0 from "./extend.vue?vue&type=style&index=0&id=bf395fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf395fea",
  null
  
)

export default component.exports